module.exports = __webpack_public_path__ + "02_medium_grey.ae6f6090.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_medium_grey.png
// module id = MVRT
// module chunks = 0